/* Auzi HEARLOOM: native mixed-metal variants.
   Genuine Shopify variants carry one-of-each through cart, checkout and orders.
   This script controls conditional visibility and the split-colour swatch only.
   It deliberately creates NO fake options and NO line-item properties. */
(function () {
  'use strict';

  if (window.AuziHearloomNativeMixed) return;
  window.AuziHearloomNativeMixed = true;

  var labels = {
    en: 'One of each — Silver + Gold vermeil',
    fr: 'Un de chaque — Argent + Vermeil',
    es: 'Uno de cada — Plata + Vermeil',
    de: 'Je eines — Silber + Gold-Vermeil',
    it: 'Uno per tipo — Argento + Vermeil',
    nl: 'Van elk één — Zilver + Goud vermeil'
  };
  var observed = new WeakSet();

  function localLabel() {
    return labels[(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || labels.en;
  }

  function product(info) {
    return !!info && /\/products\/hearloom\/?$/.test((info.dataset.url || '').split('?')[0]);
  }

  function controls(info) {
    var picker = info.querySelector('variant-selects');
    if (!picker) return null;
    var selections = Array.from(picker.querySelectorAll('select[name^="options["]'));
    if (selections.length !== 3) return null;
    return {picker:picker,set:selections[0],metal:selections[1],gemstone:selections[2]};
  }

  function findMix(select) {
    return Array.from(select.options).find(function (option) {
      return /(one of each|un de chaque|uno de cada|je eines|uno per tipo|van elk)/i.test(option.value);
    });
  }

  function isPair(select) {
    if (!select) return false;
    return select.selectedIndex > 0 &&
      !/(individual|single|individuel|individuell|singolo|único)/i.test(select.value);
  }

  function available(info, selectors, mix) {
    var data = selectors.picker.querySelector('[data-auzi-variants]');
    if (!data) return false;
    try {
      var model = JSON.parse(data.textContent);
      var values = [selectors.set.value, mix.value, selectors.gemstone.value];
      var v = model.find(function (candidate) {
        return candidate.options && candidate.options.length === 3 &&
          candidate.options.every(function (x, i) { return x === values[i]; });
      });
      return !!(v && v.available && Number(v.inventoryQuantity) > 0);
    } catch (_) {
      return false;
    }
  }

  function sync(info) {
    if (!product(info)) return;
    var fields = controls(info);
    if (!fields) return;
    var mix = findMix(fields.metal);
    if (!mix) return;

    var pair = isPair(fields.set);
    var enabled = pair && available(info, fields, mix);
    if (mix.hidden !== !pair) mix.hidden = !pair;
    if (mix.disabled !== !enabled) mix.disabled = !enabled;

    // Moving from a mixed pair back to Individual must select a valid single.
    if (!pair && fields.metal.value === mix.value) {
      var normal = Array.from(fields.metal.options).find(function (o) {
        return o !== mix && /(gold|vermeil)/i.test(o.value);
      }) || Array.from(fields.metal.options).find(function (o) { return o !== mix; });
      if (normal) {
        fields.metal.value = normal.value;
        fields.metal.dispatchEvent(new Event('change', {bubbles:true}));
      }
      return;
    }

    var wrap = fields.metal.closest('[data-auzi-visual-wrap]');
    var isActive = enabled && fields.metal.value === mix.value;
    if (!wrap) return;
    wrap.classList.toggle('auzi-mixed-metal-selected', isActive);

    if (isActive) {
      var display = wrap.querySelector('[data-auzi-visual-value]');
      if (display && display.textContent !== localLabel()) {
        display.textContent = localLabel();
      }
    }
  }

  function attach(info) {
    if (!product(info) || observed.has(info)) return;
    observed.add(info);
    var observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (m) {
        return m.target.closest('variant-selects') ||
          Array.from(m.addedNodes).some(function (n) {
            return n.nodeType === 1 && (n.matches('variant-selects') || n.querySelector('variant-selects'));
          });
      })) sync(info);
    });
    observer.observe(info, {subtree:true,childList:true});
    sync(info);
  }

  function scan() { document.querySelectorAll('product-info').forEach(attach); }

  document.addEventListener('input', function (event) {
    if (event.target.matches('variant-selects select[name^="options["]')) {
      var info = event.target.closest('product-info');
      if (product(info)) {
        sync(info);
        requestAnimationFrame(function () { if (info.isConnected) sync(info); });
      }
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.matches('variant-selects select[name^="options["]')) {
      var info = event.target.closest('product-info');
      if (product(info)) {
        sync(info);
        requestAnimationFrame(function () { if (info.isConnected) sync(info); });
      }
    }
  }, true);
  document.addEventListener('product-info:loaded', function (event) {
    var info = event.target.closest('product-info');
    if (info) attach(info);
  });
  document.addEventListener('shopify:section:load', scan);

  var style = document.createElement('style');
  style.textContent =
    '.auzi-mixed-metal-selected [data-auzi-visual-dot]{' +
      'background:linear-gradient(90deg,#e4e8e9 0%,#a5a9ae 48%,#d2a022 50%,#f4d56b 100%)!important;}' +
    '.auzi-mixed-metal-selected [data-auzi-visual-value]{' +
      'font-size:clamp(1.2rem,2.5vw,1.6rem);white-space:nowrap;' +
      'overflow:hidden;text-overflow:ellipsis;max-width:100%;}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
})();